/**
 * One number of an SVG path `d`, exponent included (`6.1e-17`, `2E+2`): the arc sampler and `scalePathD` read the
 * same numbers, so a fraction measured on `d` lands on the curve the scaled `d` draws.
 */
export const PATH_NUMBER = String.raw`-?\d+(?:\.\d+)?(?:[eE][-+]?\d+)?`;
